<template>
  <div id="captcha">
    <!-- refactor -->
    <Verify
      ref="Verify"
      @success="callRemoteCaptcha"
      @error="error"
      :explain="lang[langtype].explain"
      :finishText="lang[langtype].finishText"
      :barSize="barSize"
      :blockSize="blockSize"
    ></Verify>
    <img v-if="showImage" :src="imgStr" :width="imgWidth" :height="imgHeight" @click="refreshIt" />
  </div>
</template>

<script>
import Verify from './verify.vue';
import axios from 'axios';
export default {
  name: 'App',
  components: {
    Verify: Verify,
  },
  props: {
    langtype: {
      type: String,
      default: ''
    },
  },
  // watch: {
  //   langtype: {
  //     immediate: true,
  //     handler(val) {
  //       console.log(111);
  //     }
  //   }
  // },

  data() {
    return {
      lang: {
        en: {
          explain: 'Please hold down the slider and drag to the far right',
          finishText: 'Succeeded',
        },
        zh: {
          explain: '请按住滑块拖动到最右边',
          finishText: '成功',
        },
        ja: {
          explain: 'スライダーを押したまま右端までドラッグします',
          finishText: '成功',
        },
      },

      // 滑动块的大小
      blockSize: { width: '49px', height: '40px' },
      // 滑块槽宽度和高度
      barSize: { width: '355px', height: '38px' },
      // 滑块槽居中
      bar_margin: 'auto',
      // 说明文字
      // explain: 'Slide to right',
      showImage: false,
      // 验证码接口
      captcha_img_src: '/iam/captcha',
      imgStr: '',
      token: '',
      status: 'FAIL',
      imgWidth: '0px',
      imgHeight: '0px',
    };
  },
  watch: {
    // langtype:{
    //   immediate:true,
    //   handler(newVal) {
    //     this.langtype = newVal;
    //     // if (newVal == 'zh') {
    //     //   this.explain = '按住滑块，拖动到最右边';
    //     // }
    //     // if (newVal == 'en') {
    //     //   this.explain = 'Slide to Right';
    //     // }
    //     // console.log(this.explain);
    //   }
    // },
  },
  mounted() {},
  methods: {
    // 获取后端的图形验证码数据并生成图像
    callRemoteCaptcha() {
      axios
        .post(this.captcha_img_src)
        .then(response => {
          this.showImage = true;
          this.imgStr = response.data.img_str;
          this.token = response.data.token;
          // this.imgWidth = response.data.width + "px";
          this.imgWidth = '357px';
          this.imgHeight = response.data.height + 'px';
          this.status = 'SUCCESS';
          this.$emit('tokenTransfer', this.token, this.status);
        })
        .catch(response => {
          this.showImage = false;
          this.token = '';
          this.status = 'FAIL';
          this.$emit('tokenTransfer', this.token, this.status);
          this.$refs.Verify.refresh();
        });
    },
    // 未拖动到指定位置的错误处理
    error() {
      //  error
    },
    // 当看不清图片的重置
    refreshIt() {
      this.showImage = false;
      this.token = '';
      this.$emit('tokenTransfer', this.token);
      this.$refs.Verify.refresh();
    },
  },
};
</script>
